export const SET_SIGNUP_TYPE = 'SET_SIGNUP_TYPE';
export const SET_INFO = 'SET_INFO';
export const SET_INFO_LOADING = 'SET_INFO_LOADING';
